import NotFound from "./NotFound";

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
